import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'checkliste';
  currentStep: number = 1;
  isCompleted: boolean = false;
  formdata: any = FormGroup;
  appHasPassed: boolean = true;
  rating: number = 0.0;
  conclusion: string = '';

  wizard1 = {
    choices: [
      { 
        weight: 5, 
        name: '<p>Die App beschreibt den konkreten Anwendungsbereich, z.B. tägliche Erinnerung an die Einnahme von Medikamenten.</p>',
        text: { title: 'Zweck und Funktionalität', description: 'Unabhängig von individuellen Anforderungen an eine App, sollte diese im Allgemeinen folgende Punkte erfüllen, um sicher und stabil zu laufen:'}
      },
      { 
        weight: 5, 
        name: 'Die App klärt über die eigenen Grenzen auf (Bsp.: Erklärung in der App, dass ein Arztbesuch nicht durch die Nutzung dieser App ersetzt werden kann).'
      },
      { 
        weight: 2.5, 
        name: 'Das letzte Update der App wurde innerhalb der letzten 6 Monate (Richtwert) bereitgestellt.',
      },
      { 
        weight: 2.5, 
        name: 'Die Anwendung läuft stabil und führt nicht zu Abbrüchen oder Neustarts.',
      },
      {  
        weight: 10, 
        name: 'Die App stellt <u>keine</u> abschließende Diagnose mit sich daraus ableitenden Behandlungsempfehlungen.',
        text: {title: 'Diagnose- und Behandlungs-Apps', description: 'Prüfen Sie, ob folgende zwei Punkte in jedem Fall auf eine App zutreffen:'}
      },
      {  
        weight: 5, 
        name: 'Die App dient der Therapieunterstützung (z.B. Aufzeichnung von Werten).' 
      },
      {  
        weight: 2.5, 
        name: 'Die App weist viele gute Bewertungen (vieler verschiedener) Nutzer auf.',
        text: { title: 'Bewertungen durch andere Nutzer', description: ''}
      }
    ]
  };

  wizard2 = {
    choices: [
      { 
        weight: 5, 
        name: 'Die App wurde zertifiziert und besitzt ein vertrauenswürdiges Siegel.',
        text: { title: 'Siegel oder Zertifizierung', description: ''}
      },
      {  
        weight: 2.5, 
        name: 'Die mit dem Siegel verbundenen Bewertungskriterien sind verständlich und nachvollziehbar.'
      },
      { 
        weight: 5,
        ko_criteria: 1, 
        is_parent: 1,
        name: 'Die App besitzt eine Datenschutzerklärung und diese…',
        text: { title: 'Datenschutzerklärung', description: 'Allgemein sollte eine App eine Datenschutzerklärung aufweisen, die folgende Punkte erfüllen sollte:'}
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'ist gut auffindbar und einsehbar (Sie finden diese z.B. direkt in der App, auf der Website oder in den jeweiligen Stores der Anbieter).',
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'informiert über Art, Umfang und Zweck der Erhebung von und des Umgangs mit Daten sowie über eine mögliche Weitergabe der Daten an Dritte.' 
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'gibt an, wo (in welchem Land) und wie (verschlüsselt/anonymisiert) Ihre Daten gespeichert werden.',
      },
      { 
        weight: 5, 
        is_sub: 1,
        name: 'gibt an, ob und wie (per Mail, postalisch etc.) Sie der Datenspeicherung widersprechen können.' 
      },
      { 
        weight: 5, 
        name: 'Die App fordert nur die persönlichen Daten ein, die für die Funktionalität wichtig erscheinen.',
        text: { title: 'Funktions- und Datenzugriff', description: 'Allgemein sollten Apps folgende Eigenschaften aufweisen, wenn sie Ihre persönlichen Daten fordern und/oder aufzeichnen:'}
      },
      { 
        weight: 5, 
        name: 'Zugriffsberechtigungen auf Funktionen des mobilen Endgerätes (z.B. Zugriff auf die Standortfreigabe mittels GPS oder auf den Kalender) werden nur angefordert, um die Nutzung der App zu gewährleisten.' 
      },
      { 
        weight: 5, 
        name: 'Die App bietet die Möglichkeit, dass erhobene und gespeicherte Daten wieder gelöscht werden können. Da meistens ein vollständiges Löschen der Daten nicht möglich ist, sollten Sie immer genau überlegen, welche Daten Sie preisgeben.' 
      }
    ]
  };

  wizard3 = {
    choices: [
      { 
        weight: 5, 
        ko_criteria: 1,
        name: 'Name und Anschrift des Anbieters. Besonderheit bei juristischen Personen (z.B. GmbH oder AG): Angabe der Rechtsform und der Vertretungsberechtigten.',
        text: { title: 'Impressum', description: 'Ein Impressum einer App muss mindestens enthalten:'},
      },
      { 
        weight: 5, 
        name: 'Angaben zur direkten und unmittelbaren Kontaktaufnahme (Telefon- oder Telefax-Nummer oder E-Mail-Adresse).',
      },
      { 
        weight: 5, 
        name: 'Der finanzielle Hintergrund wird ersichtlich, z.B. <br><br> • Die App refinanziert sich selber und ist kostenpflichtig. <br><br> • Die Kosten für die App werden von der Krankenkasse erstattet (sehr selten). <br><br> • Die App wird über Sponsoren und/oder durch Fördermittel finanziert.<br><br>',
        text: { title: 'Finanzierungsform und finanzieller Hintergrund', description: ''}, 
      },
      { 
        weight: 5, 
        name: 'Die App ist neutral d.h. die Inhalte sind nicht durch kommerzielle Interessen beeinflusst, z.B. <br><br> • Die App wirbt nicht für ein bestimmtes Produkt. <br><br> • Die App wird von einem öffentlichen oder gemeinnützigen Träger betrieben.',
      }
    ]
  };


  constructor(private formsModule: FormsModule, private formBuilder: FormBuilder) {
    this.formdata = this.formBuilder.group({
      wizard1_choices: new FormArray([]),
      wizard2_choices: new FormArray([]),
      wizard3_choices: new FormArray([])
    });

    this.addCheckboxes();
  }

  private addCheckboxes() {
    this.wizard1.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard1_choices as FormArray).push(control);
    });

    this.wizard2.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard2_choices as FormArray).push(control);
    });

    this.wizard3.choices.map((o, i) => {
      const control = new FormControl(false); // checked = false
      (this.formdata.controls.wizard3_choices as FormArray).push(control);
    });
  }

  onCheckboxChange(checkbox, checked) {
    this.formdata.controls.wizard2_choices.value.forEach((value, index) => {
      if(checkbox.hasOwnProperty('is_parent') && this.wizard2.choices[index].hasOwnProperty('is_sub')) {
        if(!checked) {
          this.formdata.controls.wizard2_choices.controls[index].setValue(false);
        }
      } else if(checkbox.hasOwnProperty('is_sub') && this.wizard2.choices[index].hasOwnProperty('is_parent')) {
        if(checked) {
          this.formdata.controls.wizard2_choices.controls[index].setValue({value: true});
        }
      }
    });
  }

  onStep1Next() {
    this.currentStep = 2;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onStep2Next() {
    this.currentStep = 3;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onStep3Next() {
    this.currentStep = 3;
    window.top.scroll(0,0);
    window.scroll(0,0);
  }

  onComplete() {
      window.top.scroll(0,0);
      window.scroll(0,0);
     this.isCompleted = true;

     this.formdata.controls.wizard1_choices.value.forEach((choice, index) => {
       if(this.wizard1.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard1.choices[index].weight;
       }
     });

     this.formdata.controls.wizard2_choices.value.forEach((choice, index) => {
       if(this.wizard2.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard2.choices[index].weight;
       }
     });

     this.formdata.controls.wizard3_choices.value.forEach((choice, index) => {
       if(this.wizard3.choices[index].hasOwnProperty('ko_criteria') && !choice) {
         this.appHasPassed = false;
       } else if(choice) {
         this.rating += this.wizard3.choices[index].weight;
       }
     });

     if(this.appHasPassed && this.rating >= 0 && this.rating <= 40) {
       this.conclusion = "Die von Ihnen geprüfte App weist nur sehr geringe Übereinstimmungen mit den empfohlenen Anforderungen an Gesundheits-App auf. Sie sollten sich über die Risiken bewusst sein, wenn sie diese App trotzdem nutzen.";
     } else if(this.appHasPassed && this.rating > 40 && this.rating <= 84) {
       this.conclusion = "Die von Ihnen überprüfte App weist viele Übereinstimmungen mit den empfohlen Kriterien auf. Dennoch werden einige Kriterien nicht erfüllt. Bitte wägen Sie selbst ab, ob die erfüllten Kriterien für Sie ausreichend sind.";
     } else if(this.appHasPassed && this.rating > 84 && this.rating <= 99) {
       this.conclusion = "Die von Ihnen App erfüllt fast alle Kriterien, die das Aktionsbündnis Patientensicherheit empfiehlt.";
     } else if(this.appHasPassed && this.rating > 99) {
       this.conclusion = "Die von Ihnen App erfüllt alle Kriterien, die das Aktionsbündnis Patientensicherheit empfiehlt.";
     } else if(!this.appHasPassed) {
       this.conclusion = "In der geprüften App existiert keine Datenschutzerklärung oder/und kein Impressum, weswegen von einer Anwendung dieser App abgeraten wird.";
     }
  }

  exit() {
    window.top.location.href = 'https://www.aps-ev.de/'; //window.top.location.origin
  }

  reload() {
    window.location.reload();
    window.top.scroll(0,0);
    window.scroll(0,0);
  }
}
